export const tablepadding = { padding: '15px' }